import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../store/index';
import * as Store from '../store/Store';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

type IdentityProps =
    Store.StoreState &
    typeof Store.actionCreators &
    RouteComponentProps<{}>;

interface IRowData {
    dataIndex: number;
    index: number;
}
interface IRow {
    data: IRowData[];
}


const columns: MUIDataTableColumnDef[] = [
    { name: "Code", label: 'Codice' },
    { name: "Denomination", label: 'Denominazione' },
    
];
const Identities = (props: IdentityProps) => {
    useEffect(() => {
        props.requestIdentityList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        props.requestIdentityList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isLoadingDelete]);
    const onEditIdentity = (id: number) => () => {
        props.history.push(`/identity/edit/${id}`);
    }
    const onNewIdentity = () => {
        props.history.push(`/identity/create`);
    }
    const onDeleteIdentity = (row: IRow) => () => {
        var { identities } = props;
        for (var i in row.data) {
            var data: IRowData = row.data[i];
            var identity: Store.Identity = identities[data.dataIndex];
            props.deleteIdentity(identity.ID);
        }
    }
    const customToolbar = () => {
        return <React.Fragment>
            {(props.CurrentUser?.IsAdmin || (props.CurrentUser?.Permissions.CreateIdentities || false)) && <Tooltip title="Nuovo">
                <IconButton onClick={onNewIdentity}>
                    <AddIcon />
                </IconButton>
            </Tooltip>}
        </React.Fragment>;
    }
    const customToolbarSelect = (selectedRows: IRow) => {
        var { identities } = props;
        var data: IRowData = selectedRows.data[0];
        var identity: Store.Identity = identities[data.dataIndex];
        return <div>
            {(props.CurrentUser?.IsAdmin || (props.CurrentUser?.Permissions.CreateIdentities || false)) && selectedRows.data.length === 1 && <Tooltip title="Modifica">
                <IconButton onClick={onEditIdentity(identity.ID)}>
                    <EditIcon />
                </IconButton>
            </Tooltip>}
            {(props.CurrentUser?.IsAdmin || (props.CurrentUser?.Permissions.DeleteIdentities || false)) && <Tooltip title="Elimina">
                <IconButton onClick={onDeleteIdentity(selectedRows)}>
                    <DeleteIcon />
                </IconButton>
            </Tooltip>}
        </div>;
    }

    if (props.isLoading) {
        return <div>Loading</div>;
    }

    return <div>
        <MUIDataTable
            title="Identities"
            data={props.identities}
            columns={columns}
            options={{
                filterType: "checkbox",
                download: false,
                onRowsDelete: onDeleteIdentity,
                print: false,
                viewColumns: false,
                filter: false,
                selectableRowsHeader: props.CurrentUser?.IsAdmin || (props.CurrentUser?.Permissions.CreateIdentities || false) || (props.CurrentUser?.Permissions.DeleteIdentities || false),
                isRowSelectable: () => props.CurrentUser?.IsAdmin || (props.CurrentUser?.Permissions.CreateIdentities || false) || (props.CurrentUser?.Permissions.DeleteIdentities || false),
                customToolbar: customToolbar,
                customToolbarSelect: customToolbarSelect
            }}
        />
    </div>;
}

export default connect(
    (state: ApplicationState) => state.store,
    Store.actionCreators
)(Identities as any);
